import React from 'react'
import styled from "styled-components"
import Acc from '@mui/icons-material/AccountCircle';
import Box from '@mui/icons-material/AddBox';
import Home from '@mui/icons-material/Home';
import { Link, useNavigate } from "react-router-dom";
import { logout } from "../../redux/UserRedux";
import { useDispatch } from "react-redux";
import Swal from 'sweetalert2';

const Sidebar = styled.div`
  border-right: 0.1px solid #252525;
  width: 250px;
  min-height: 100vh;

  @media screen and (max-width:768px){
width: 70px;
}

  .cajita{
    border-bottom: 0.5px solid #252525;
    margin-top: -35px;
    @media screen and (max-width:768px){
      display: none;
    }}
`

const Top= styled.div`
  display: flex;
  align-items: left;
  justify-content: left;
  `

const Logo = styled.div`
  height: 60px;
  margin: 15px;
  margin-left: 18px;
  

  .Moha{
  font-size: 30px;
  line-height: 100px;
  font-weight: bold;
  color: #252525;
  cursor: pointer;
  text-decoration: none;
  @media screen and (max-width:768px){
  display: none;
}
}
`

const Lista = styled.div`
  display: flex; 
  letter-spacing: 2px;
  line-height: 4ex;
  margin-top: 80px;
  gap: 20px;

  @media screen and (max-width:768px){
      width: 35px;
     min-height: 100vh;

    }

 li:hover{
  background-color: #ebebeba2;
  border-radius: 24px;
  width: 165px;
  height: 35px;
  margin-left: -5px;
  @media screen and (max-width:768px){
     width: 0;
margin-left: 0;
    }
}

ul{
  margin-bottom: 50px;
  margin-left: -20px;
  font-size: 18px;
  font-weight: 500;
  @media screen and (max-width:768px){
  flex-wrap: wrap;
  display: flex;
}
}
.icon{
  text-decoration: none;
  color: #252525;
  line-height: 17px;
  @media screen and (max-width:768px){
    span{
      display: none;
    }
}
}

.logoutBtn{
  border: none;
  background-color: transparent;
}

span{
  font-size: 18px;
  display: block;
  position: relative;
  left: 40px;
  top: -23px;
}

.item{
font-size:30px ;
@media only screen and (max-width: 480px) {
        width: 40px; 
        height: 40px;
        margin-left: -15px;
        display: block;
        position: relative;
        align-items: center;
        justify-content: left;
    }
  }
`



const Side = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const handleLogout = async (e) => {
    e.preventDefault();

    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    })
    
    Toast.fire({
      icon: 'success',
      title: 'Cerrando Sesión'
    })

    dispatch(logout());
    setTimeout(() => {
      navigate("/login");
    }, 1500);
  };

  return (
    <>
    <Sidebar>
      <div className='cajita'>
      <Top>
       <Logo>
      <Link to="/admin" className='Moha'>MOHA</Link>
      </Logo>
      </Top>
      </div>
    <Lista>
      <ul>
      <ul>
        <li>
          <Link to="/admin" className='icon'> 
            <Home className='item'></Home>
            <span>INICIO</span>
            </Link>
        </li>
      </ul>
      <ul>
        <li>
          <Link to="/admin/eventos/nuevo" className='icon'>
        <Box className='item'/>
            <span>NUEVO</span>
            </Link>
        </li>
      </ul>
      <ul>
        <li className='icon'>
          <button className='icon logoutBtn' onClick={handleLogout}>
      <Acc className='item'/>
            <span>SALIR</span>
            </button>
        </li>
      </ul>
      </ul>
    </Lista>
    </Sidebar>
    </>
  )
}

export default Side